import { h } from 'preact';
import * as BaseComp from 'components/pages/home/home.js';
import { Link } from 'components/core/link/link.js';
import s from 'components/pages/home/home.sss';

export default class Home extends BaseComp.default {

	getExtraContent() {
		return <div class={s.newsletterLinkContainer}>
			<Link linkClass={s.newsletterLink} pageId="newsletter">{this.props.appData.copy.$NEWSLETTER_CTA}</Link>
		</div>;
	}

}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
